export default __webpack_public_path__ + "static/media/sadisticsoul.261701ed.png";